import { addMonths } from '@shared/date/reference-month'
import type { ReferenceMonth } from '@shared/date/reference-month'

/**
 * Quais meses aparecem como chip, e em que ordem.
 *
 * `Docs/04-Design/Telas/Transações.md` desenha `Julho Junho Maio Abril`: os mais
 * recentes primeiro, quatro deles. Esta função responde **quais** quatro.
 *
 * ## A regra, e o que ela precisa garantir
 *
 * Duas coisas, e a segunda é a que complica:
 *
 * 1. **O mês selecionado está sempre na janela** — um seletor que não mostra o
 *    que está selecionado é pior que nenhum.
 * 2. **Dá para ir e voltar sem sair da janela.** Se ela terminasse no mês
 *    selecionado, avançar exigiria um controle à parte; e a nota já substituiu
 *    os botões "Mês anterior"/"Próximo mês" pelos chips.
 *
 * Daí a janela terminar **um mês à frente do selecionado**, sem nunca passar do
 * mês corrente. Quem está em julho vê `Agosto Julho Junho Maio`; quem está em
 * agosto — o corrente — vê `Agosto Julho Junho Maio` também, e não um setembro
 * que ainda não aconteceu.
 *
 * ## Mês futuro na URL não é recusado
 *
 * `?mes=2027-03` é alcançável — parcela de 12x vive até lá. A janela então
 * termina **nele**, porque a regra 1 vale sempre: mostrar o selecionado importa
 * mais do que a simetria da janela.
 */
export function monthChips(
  selected: ReferenceMonth,
  current: ReferenceMonth,
  count = 4,
): ReferenceMonth[] {
  const umAFrente = addMonths(selected, 1)
  // `min(um à frente, corrente)` — mas o selecionado manda quando está no
  // futuro, senão ele sairia da janela.
  const fim = selected > current ? selected : (umAFrente > current ? current : umAFrente)

  return Array.from({ length: count }, (_, i) => addMonths(fim, -i))
}
